import React, { useState } from 'react';
import { Container, Content, Form, Button, Panel, Message } from 'rsuite';
import { useNavigate, useSearchParams } from 'react-router-dom';

import NavigationBar from '../Shared/NavigationBar';
import { API_BASE } from '../../helpers/authFetch';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const handleSubmit = async () => {
    setError('');
    setSuccess('');

    if (!password || !confirmPassword) {
      setError('All fields are required');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${API_BASE}/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || 'Password reset failed');
        return;
      }

      setSuccess('Password reset successfully! Redirecting to login...');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError('Unable to connect to server');
    } finally {
      setLoading(false);
    }
  };

  const styles = {
    panel: {
      maxWidth: 400,
      margin: '60px auto',
    },
  };

  return (
    <>
      <NavigationBar />
      <Container>
        <Content>
          <Panel header="Reset Password" bordered style={styles.panel}>
            {error && (
              <Message type="error" showIcon style={{ marginBottom: 16 }}>
                {error}
              </Message>
            )}
            {success && (
              <Message type="success" showIcon style={{ marginBottom: 16 }}>
                {success}
              </Message>
            )}
            {!token ? (
              <Message type="error" showIcon>
                Invalid reset link
              </Message>
            ) : (
              <Form fluid>
                <Form.Group>
                  <Form.ControlLabel>New Password</Form.ControlLabel>
                  <Form.Control
                    name="password"
                    type="password"
                    value={password}
                    onChange={setPassword}
                    placeholder="Enter new password"
                  />
                </Form.Group>
                <Form.Group>
                  <Form.ControlLabel>Confirm New Password</Form.ControlLabel>
                  <Form.Control
                    name="confirmPassword"
                    type="password"
                    value={confirmPassword}
                    onChange={setConfirmPassword}
                    placeholder="Confirm new password"
                  />
                </Form.Group>
                <Form.Group>
                  <Button
                    appearance="primary"
                    block
                    loading={loading}
                    onClick={handleSubmit}
                  >
                    Reset Password
                  </Button>
                </Form.Group>
              </Form>
            )}
          </Panel>
        </Content>
      </Container>
    </>
  );
};

export default ResetPassword;
